import { render, staticRenderFns } from "./ChannelAgent.vue?vue&type=template&id=957a7db2&scoped=true&"
import script from "./ChannelAgent.vue?vue&type=script&lang=js&"
export * from "./ChannelAgent.vue?vue&type=script&lang=js&"
import style0 from "./ChannelAgent.vue?vue&type=style&index=0&id=957a7db2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957a7db2",
  null
  
)

export default component.exports